module.exports = __webpack_public_path__ + "img/ic-warning.cee8a77f.svg";